import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { ProductInstrumentStyled } from "./styled";
import { useTranslation } from "react-i18next";

const ProductInstrument = ({
  theme_standard,
  brand,
  product_en,
  product_th,
  model,
  series,
  serial_no,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { i18n } = useTranslation(["history"]);

  return (
    <ProductInstrumentStyled
    // statusBg={renderStatus && renderStatus.bgColor}
    // status={renderStatus.label}
    >
      <div className={customClass}>
        <div className="product_warrantee_container">
          <div className="warrantee_title">
            {i18n.language === "en"
              ? "Musical instrument details"
              : "รายละเอียดเครื่องดนตรี"}
          </div>

          <div className="img_wrap">
            {/* <img
              className="product_img"
              alt="product"
              src={src ? src : "/assets/images/mockups/piano.png"}
            /> */}
          </div>
          <div className="title">
            {i18n.language === "en" ? product_en : product_th}
          </div>
          {/* {renderStatus && (
            <div className="pw_status">
              {t(renderStatus.label, { ns: "history" })}
            </div>
          )} */}
          <div className="pw_row">
            <div className="label">
              {i18n.language === "en" ? "Description : " : "รายละเอียด : "}
            </div>
            <div className="value">{brand}</div>
          </div>
          <div className="pw_row">
            <div className="label">
              {i18n.language === "en"
                ? "Description Line 2 : "
                : "รายละเอียด เพิ่มเติม : "}
            </div>
            <div className="value">{model}</div>
          </div>
          <div className="pw_row">
            <div className="label">
              {i18n.language === "en" ? "Item Number " : "หมายเลขสินค้า "} :{" "}
            </div>
            <div className="value">{series}</div>
          </div>
          <div className="pw_row">
            <div className="label">
              {i18n.language === "en" ? " Serial No" : " หมายเลขซีเรียล"} :{" "}
            </div>
            <div className="value">{serial_no}</div>
          </div>
        </div>
      </div>
    </ProductInstrumentStyled>
  );
};

ProductInstrument.propTypes = {};

export default ProductInstrument;
